import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  navigate(event) {
    const path = event.target.value
    if (!path) return
    event.target.value = ""
    Turbo.visit(path)
  }
}
